export default "__VITE_ASSET__rHDF0MGX__"